import React from 'react'
import SectionTitle3 from '../SectionTitle3'
import { Link } from 'react-router-dom'
import bShape1 from '../../images/blog/Vector3.png'
import bShape2 from '../../images/blog/Vector4.png'
import { useTranslation } from 'react-i18next'

const BlogSectionS2 = ({ blogs, blogsIsLoading, blogsIsError }) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    const { t } = useTranslation();

    return (

        <section className="wpo-blog-section-s2 section-padding" id="blog">
            <div className="container">
                <SectionTitle3
                    subTitle={t('sectionTitle.blogSection.subtitle')}
                    MainTitle={t('sectionTitle.blogSection.mainTitle')}
                />
                <div className="wpo-blog-items">
                    <div className="row">
                        {blogsIsLoading ? <p>{t("loading")}...</p> : blogsIsError ? <p>{t("error")}</p> : (
                            blogs.slice(0, 3).map((blog, Bitem) => (
                                <div className="col col-lg-4 col-md-6 col-12" key={Bitem}>
                                    <div className="wpo-blog-item">
                                        <div className="wpo-blog-img">
                                            <img src={`${process.env.REACT_APP_API_URL}/api/images/${blog?.data?.thumbnail}`} alt={blog?.data?.title} />
                                            <div className="thumb">{blog?.data?.categories[0]}</div>
                                        </div>
                                        <div className="wpo-blog-content">
                                            <ul>
                                                <li>{blog.publishedAt.slice(0, 10)}</li>
                                                <li>By <Link onClick={ClickHandler} to={`/blog-single/${blog?.slug}`}>{blog?.data?.author}</Link></li>
                                            </ul>
                                            <h2><Link onClick={ClickHandler} to={`/blog-single/${blog?.slug}`}>{blog?.data?.title}</Link></h2>
                                            <p>{blog?.data?.description?.slice(0, 100)}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}

                    </div>
                </div>
            </div>
            <div className="vector-1">
                <img src={bShape1} alt="" />
            </div>
            <div className="vector-2">
                <img src={bShape2} alt="" />
            </div>
        </section>
    )
}

export default BlogSectionS2;